// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Cv-z","tooltipWrapper":"Dv-z","icon":"Ev-z","tooltip":"Fv-z","content":"Gv-z"};